enum ReviewHandlingSessionLogEntryType {
	VIEWED = 'VIEWED', NOTES = 'NOTES', ANSWERED = 'ANSWERED'
}

export default ReviewHandlingSessionLogEntryType;